'use strict'

let self

export default self = {
  container : document.getElementById('share-vertical'),
  btns : {
    facebook : null,
    twitter : null,
    linkedin : null,
    email : null
  },

  init : () => {
    self.storeBtns()
    self.registerEvents()
    self.loadFacebookSDK()
  },

  storeBtns : () => {
    self.btns.facebook = self.container.querySelector('.share-facebook')
    self.btns.twitter = self.container.querySelector('.share-twitter')
    self.btns.linkedin = self.container.querySelector('.share-linkedin')
    self.btns.email = self.container.querySelector('.share-email')
  },

  registerEvents : () => {
    self.btns.facebook.addEventListener("click", self.shareFacebook)
    self.btns.twitter.addEventListener("click", self.shareTwitter)
    self.btns.linkedin.addEventListener("click", self.shareLinkedIn)
    self.btns.email.addEventListener("click", self.shareEmail)
  },

  loadFacebookSDK : () => {
    window.fbAsyncInit = function() {
      FB.init({
        appId      : '267864150373549',
        xfbml      : true,
        version    : 'v2.10'
      });
      FB.AppEvents.logPageView();
    };

    (function(d, s, id){
       var js, fjs = d.getElementsByTagName(s)[0];
       if (d.getElementById(id)) {return;}
       js = d.createElement(s); js.id = id;
       js.src = "//connect.facebook.net/en_US/sdk.js";
       fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  },

  shareFacebook : e => {
    FB.ui({
      method: 'share',
      href: location.href,
    }, function(response){});
  },

  shareTwitter : e => {
    let text = document.querySelector('.detail-nav .listing-title').innerHTML
    let url = encodeURI(location.href)
    let href = `https://twitter.com/intent/tweet?text=${text}&url=${url}`

    window.open(href, "_blank")
  },

  shareLinkedIn : e => {
    let text = document.querySelector('.detail-nav .listing-title').innerHTML
    let url = encodeURI(location.href)
    let href = `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${text}&summary=${text}`

    window.open(href, "_blank")
  },

  shareEmail : e => {
    let text = document.querySelector('.detail-nav .listing-title').innerHTML
    let url = encodeURI(location.href)
    let body = `Check out this awesome listing - ${url}`

    location.href = `mailto:Jason@JasonHutchison.ca?subject=${text}&body=${body}`
  }

}
